<template>
  <div>
    <div class="width100 margin-auto">
      <div class="margin-top10 flex-between">
        <div class="backwhite width13 border-rd3" style="background: #fff">
          <!-- 企业数据 -->
          <div
            class="
              width100
              margin-auto
              pad-top10 pad-bot20
              cursorpointer
              border-rd3
            "
            style="min-height: 80vh"
          >
            <div
              class="prompt-item"
              @click="toInvestmentprojects(1)"
              :class="{ aaa: isaaa === 1 }"
            >
              <p class="pad-left20">工商基础信息</p>
            </div>
            <div
              class="prompt-item"
              @click="toFixedassets(2)"
              :class="{ aaa: isaaa === 2 }"
            >
              <p class="pad-left20">固定资产情况</p>
            </div>
            <div
              class="prompt-item"
              @click="toTechnicaltransformation(3)"
              :class="{ aaa: isaaa === 3 }"
            >
              <p class="pad-left20">技改项目管理</p>
            </div>
            <div
              class="prompt-item"
              @click="torevenueinvestment(4)"
              :class="{ aaa: isaaa === 4 }"
            >
              <p class="pad-left20">企业营收及研发投入</p>
            </div>
            <div
              class="prompt-item"
              @click="toFinancingloans(5)"
              :class="{ aaa: isaaa === 5 }"
            >
              <p class="pad-left20">融资贷款情况</p>
            </div>
            <div
              class="prompt-item"
              @click="toCooperativeColleges(6)"
              :class="{ aaa: isaaa === 6 }"
            >
              <p class="pad-left20">产学研合作</p>
            </div>
            <div
              class="prompt-item"
              @click="toresearchdevelopment(7)"
              :class="{ aaa: isaaa === 7 }"
            >
              <p class="pad-left20">研发领域</p>
            </div>
            <div
              class="prompt-item"
              @click="toscientifictechnological(8)"
              :class="{ aaa: isaaa === 8 }"
            >
              <p class="pad-left20">重大科技项目</p>
            </div>
            <div
              class="prompt-item"
              @click="toParticipationstandard(9)"
              :class="{ aaa: isaaa === 9 }"
            >
              <p class="pad-left20">参编标准</p>
            </div>
            <div
              class="prompt-item"
              @click="toinformationsoftware(10)"
              :class="{ aaa: isaaa === 10 }"
            >
              <p class="pad-left20">信息化软件应用</p>
            </div>
            <div
              class="prompt-item"
              @click="toQualificationmanagement(11)"
              :class="{ aaa: isaaa === 11 }"
            >
              <p class="pad-left20">资质管理</p>
            </div>
            <div
              class="prompt-item"
              @click="toEnterprisehonor(12)"
              :class="{ aaa: isaaa === 12 }"
            >
              <p class="pad-left20">企业荣誉</p>
            </div>
          </div>
        </div>
        <!-- 工商基础信息 -->
        <toInvestmentprojects v-if="Investmentproject"></toInvestmentprojects>
        <!-- 固定资产情况 -->
        <toFixedassets v-if="Fixedassets"></toFixedassets>
        <!-- 技改项目管理 -->
        <toTechnicaltransformation
          v-if="Technicaltransformation"
        ></toTechnicaltransformation>
        <!-- 企业营收及研发投入 -->
        <torevenueinvestment v-if="revenueinvestment"></torevenueinvestment>
        <!-- 融资贷款情况 -->
        <toFinancingloans v-if="Financingloans"></toFinancingloans>
        <!-- 合作院校 -->
        <toCooperativeColleges
          v-if="CooperativeColleges"
        ></toCooperativeColleges>
        <!-- 研发领域 -->
        <toresearchdevelopment
          v-if="researchdevelopment"
        ></toresearchdevelopment>
        <!-- 重大科技项目 -->
        <toscientifictechnological
          v-if="scientifictechnological"
        ></toscientifictechnological>
        <!-- 参编标准 -->
        <toParticipationstandard
          v-if="Participationstandard"
        ></toParticipationstandard>
        <!-- 信息化软件应用 -->
        <toinformationsoftware
          v-if="informationsoftware"
        ></toinformationsoftware>
        <!-- 资质管理 -->
        <toQualificationmanagement
          v-if="Qualificationmanagement"
        ></toQualificationmanagement>
        <!-- 企业荣誉 -->
        <toEnterprisehonor v-if="Enterprisehonor"></toEnterprisehonor>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 投资项目管理
import toInvestmentprojects from "./Investmentprojects.vue";
import toFixedassets from "./Fixedassets.vue";
import toTechnicaltransformation from "./Technicaltransformation.vue";
import torevenueinvestment from "./revenueinvestment.vue";
import toFinancingloans from "./Financingloans.vue";
import toCooperativeColleges from "./CooperativeColleges.vue";
import toresearchdevelopment from "./researchdevelopment.vue";
import toscientifictechnological from "./scientifictechnological.vue";
import toParticipationstandard from "./Participationstandard.vue";
import toinformationsoftware from "./informationsoftware.vue";
import toQualificationmanagement from "./Qualificationmanagement.vue";
import toEnterprisehonor from "./Enterprisehonor.vue";
import { companycate } from "@/api/business/business.api";
import { companydata, companysave } from "@/api/business/business.api";
export default {
  data() {
    return {
      errormessage: "",
      formall: false,
      dialogVisiblenull: false,
      Investmentproject: false,
      Fixedassets: false,
      Technicaltransformation: false,
      revenueinvestment: false,
      Financingloans: false,
      CooperativeColleges: false,
      researchdevelopment: false,
      scientifictechnological: false,
      Participationstandard: false,
      informationsoftware: false,
      Qualificationmanagement: false,
      Enterprisehonor: false,
      isaaa: "",
      isbbb: "",
      pages: "",
      centerid: "",
      page: [],
      number: [],
      select: [],
      form: {},
      all: {},
      alls: {},
      headmname: "",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
    };
  },
  watch: {
    windowWidth(val) {
      this.windowWidth = val;
    },
  },
  components: {
    //投资项目管理
    toInvestmentprojects,
    //固定资产情况
    toFixedassets,
    //技改项目管理
    toTechnicaltransformation,
    //企业营收及研发投入
    torevenueinvestment,
    //融资贷款情况
    toFinancingloans,
    //合作院校
    toCooperativeColleges,
    //研发领域
    toresearchdevelopment,
    //重大科技项目
    toscientifictechnological,
    //参编标准
    toParticipationstandard,
    // 信息化软件应用
    toinformationsoftware,
    //资质管理
    toQualificationmanagement,
    //企业荣誉
    toEnterprisehonor,
  },
  inject: ["reload"],
  methods: {
    changeclass(index) {
      this.isbbb = index;
    },

    itemsid(index) {
      window.sessionStorage.setItem("nummoney", 0);
      this.isaaa = "";
      this.formall = true;
      this.Investmentproject = false;
      this.Fixedassets = false;
      this.Technicaltransformation = false;
      this.revenueinvestment = false;
      this.Financingloans = false;
      this.CooperativeColleges = false;
      this.researchdevelopment = false;
      this.scientifictechnological = false;
      this.Participationstandard = false;
      this.informationsoftware = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
      this.number = [];
      this.select = [];
      this.centerid = this.pages[index].id;
      companydata({ cate_id: this.centerid }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.headmname = this.page[0].cate;
          this.page.forEach((i) => {
            if (i.type == "number") {
              this.number.push(i);
            } else if (i.type == "select") {
              this.select.push(i);
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    onSubmit(index) {
      this.number.forEach((i) => {
        let key = i.field;
        let value = i.value;
        this.all[key] = value;
      });
      this.select.forEach((j) => {
        let key = j.field;
        let value = j.value;
        this.alls[key] = value;
      });
      let muchall = Object.assign(this.all, this.alls);
      companysave(muchall).then((res) => {
        if (res.data.code == 200) {
          this.reload();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    //投资项目管理
    toInvestmentprojects(i) {
      window.sessionStorage.setItem("nummoney", 1);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.Investmentproject = true;
      this.Fixedassets = false;
      this.Technicaltransformation = false;
      this.revenueinvestment = false;
      this.Financingloans = false;
      this.CooperativeColleges = false;
      this.researchdevelopment = false;
      this.scientifictechnological = false;
      this.Participationstandard = false;
      this.informationsoftware = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
    },
    // 固定资产情况
    toFixedassets(i) {
      window.sessionStorage.setItem("nummoney", 2);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.Fixedassets = true;
      this.Investmentproject = false;
      this.Technicaltransformation = false;
      this.revenueinvestment = false;
      this.Financingloans = false;
      this.CooperativeColleges = false;
      this.researchdevelopment = false;
      this.scientifictechnological = false;
      this.Participationstandard = false;
      this.informationsoftware = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
    },
    //技改项目管理
    toTechnicaltransformation(i) {
      window.sessionStorage.setItem("nummoney", 3);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.Technicaltransformation = true;
      this.Fixedassets = false;
      this.Investmentproject = false;
      this.revenueinvestment = false;
      this.Financingloans = false;
      this.CooperativeColleges = false;
      this.researchdevelopment = false;
      this.scientifictechnological = false;
      this.Participationstandard = false;
      this.informationsoftware = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
    },
    //企业营收及研发投入
    torevenueinvestment(i) {
      window.sessionStorage.setItem("nummoney", 4);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.revenueinvestment = true;
      this.Technicaltransformation = false;
      this.Fixedassets = false;
      this.Investmentproject = false;
      this.Financingloans = false;
      this.CooperativeColleges = false;
      this.researchdevelopment = false;
      this.scientifictechnological = false;
      this.Participationstandard = false;
      this.informationsoftware = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
    },
    //融资贷款情况
    toFinancingloans(i) {
      window.sessionStorage.setItem("nummoney", 5);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.Financingloans = true;
      this.revenueinvestment = false;
      this.Technicaltransformation = false;
      this.Fixedassets = false;
      this.Investmentproject = false;
      this.CooperativeColleges = false;
      this.researchdevelopment = false;
      this.scientifictechnological = false;
      this.Participationstandard = false;
      this.informationsoftware = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
    },
    //合作院校
    toCooperativeColleges(i) {
      window.sessionStorage.setItem("nummoney", 6);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.CooperativeColleges = true;
      this.Financingloans = false;
      this.revenueinvestment = false;
      this.Technicaltransformation = false;
      this.Fixedassets = false;
      this.Investmentproject = false;
      this.researchdevelopment = false;
      this.scientifictechnological = false;
      this.Participationstandard = false;
      this.informationsoftware = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
    },
    //研发领域
    toresearchdevelopment(i) {
      window.sessionStorage.setItem("nummoney", 7);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.researchdevelopment = true;
      this.CooperativeColleges = false;
      this.Financingloans = false;
      this.revenueinvestment = false;
      this.Technicaltransformation = false;
      this.Fixedassets = false;
      this.Investmentproject = false;
      this.scientifictechnological = false;
      this.Participationstandard = false;
      this.informationsoftware = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
    },
    //重大科技项目
    toscientifictechnological(i) {
      window.sessionStorage.setItem("nummoney", 8);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.scientifictechnological = true;
      this.researchdevelopment = false;
      this.CooperativeColleges = false;
      this.Financingloans = false;
      this.revenueinvestment = false;
      this.Technicaltransformation = false;
      this.Fixedassets = false;
      this.Investmentproject = false;
      this.Participationstandard = false;
      this.informationsoftware = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
    },
    //参编标准
    toParticipationstandard(i) {
      window.sessionStorage.setItem("nummoney", 9);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.Participationstandard = true;
      this.scientifictechnological = false;
      this.researchdevelopment = false;
      this.CooperativeColleges = false;
      this.Financingloans = false;
      this.revenueinvestment = false;
      this.Technicaltransformation = false;
      this.Fixedassets = false;
      this.Investmentproject = false;
      this.informationsoftware = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
    },
    //信息化软件应用
    toinformationsoftware(i) {
      window.sessionStorage.setItem("nummoney", 10);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.informationsoftware = true;
      this.Participationstandard = false;
      this.scientifictechnological = false;
      this.researchdevelopment = false;
      this.CooperativeColleges = false;
      this.Financingloans = false;
      this.revenueinvestment = false;
      this.Technicaltransformation = false;
      this.Fixedassets = false;
      this.Investmentproject = false;
      this.Qualificationmanagement = false;
      this.Enterprisehonor = false;
    },
    //资质管理
    toQualificationmanagement(i) {
      window.sessionStorage.setItem("nummoney", 11);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.Qualificationmanagement = true;
      this.informationsoftware = false;
      this.Participationstandard = false;
      this.scientifictechnological = false;
      this.researchdevelopment = false;
      this.CooperativeColleges = false;
      this.Financingloans = false;
      this.revenueinvestment = false;
      this.Technicaltransformation = false;
      this.Fixedassets = false;
      this.Investmentproject = false;
      this.Enterprisehonor = false;
    },
    //企业荣誉
    toEnterprisehonor(i) {
      window.sessionStorage.setItem("nummoney", 12);
      this.isbbb = "";
      this.formall = false;
      this.isaaa = i;
      this.Enterprisehonor = true;
      this.Qualificationmanagement = false;
      this.informationsoftware = false;
      this.Participationstandard = false;
      this.scientifictechnological = false;
      this.researchdevelopment = false;
      this.CooperativeColleges = false;
      this.Financingloans = false;
      this.revenueinvestment = false;
      this.Technicaltransformation = false;
      this.Fixedassets = false;
      this.Investmentproject = false;
    },
  },
  created() {
    if (window.sessionStorage.getItem("nummoney") == 0) {
      this.formall = true;
      this.isaaa = 0;
    } else if (window.sessionStorage.getItem("nummoney") == 1) {
      this.Investmentproject = true;
      this.isaaa = 1;
    } else if (window.sessionStorage.getItem("nummoney") == 2) {
      this.Fixedassets = true;
      this.isaaa = 2;
    } else if (window.sessionStorage.getItem("nummoney") == 3) {
      this.Technicaltransformation = true;
      this.isaaa = 3;
    } else if (window.sessionStorage.getItem("nummoney") == 4) {
      this.revenueinvestment = true;
      this.isaaa = 4;
    } else if (window.sessionStorage.getItem("nummoney") == 5) {
      this.Financingloans = true;
      this.isaaa = 5;
    } else if (window.sessionStorage.getItem("nummoney") == 6) {
      this.CooperativeColleges = true;
      this.isaaa = 6;
    } else if (window.sessionStorage.getItem("nummoney") == 7) {
      this.researchdevelopment = true;
      this.isaaa = 7;
    } else if (window.sessionStorage.getItem("nummoney") == 8) {
      this.scientifictechnological = true;
      this.isaaa = 8;
    } else if (window.sessionStorage.getItem("nummoney") == 9) {
      this.Participationstandard = true;
      this.isaaa = 9;
    } else if (window.sessionStorage.getItem("nummoney") == 10) {
      this.informationsoftware = true;
      this.isaaa = 10;
    } else if (window.sessionStorage.getItem("nummoney") == 11) {
      this.Qualificationmanagement = true;
      this.isaaa = 11;
    } else if (window.sessionStorage.getItem("nummoney") == 12) {
      this.Enterprisehonor = true;
      this.isaaa = 12;
    }
    this.windowWidth = document.documentElement.clientWidth;
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        that.windowWidth = window.fullWidth; // 宽
      })();
    };
  },
};
</script>
<style scoped>
.prompt-item {
  font-size: 14px;
  color: #6a7589;
  width: 90%;
  margin: 10px auto 0;
  height: 40px;
  line-height: 40px;
}
.prompt-item:hover {
  color: #52c5cb;
  background: #eef9fa;
  border-radius: 20px;
}
.mlcons {
  font-size: 12px;
  color: #646464;
  padding-left: 20px;
}
.aaa {
  color: #52c5cb;
  /* background: #eef9fa; */
  border-radius: 20px;
}
.elformitem {
  margin-top: 20px;
  border-bottom: 1px solid #efefef;
  font-size: 14px;
  position: relative;
}
/* 利用穿透，设置input边框隐藏 */
.elformitem >>> .el-input__inner {
  border: 0;
  padding: 0 0 0 10px;
  border: 1px solid #a3a3a3;
  border-radius: 0px;
}
.elformitem >>> .el-select__inner {
  border: 0;
  padding: 0;
  width: 100%;
}
.elbutton {
  width: 80px;
  height: 32px;
  margin-top: 20px;
  font-size: 14px;
  background: #636bff;
  color: white;
}
.elunit {
  position: absolute;
  top: 28px;
  right: 20px;
  color: #2e65ff;
  font-size: 12px;
  border-radius: 5px;
}
.rightboxss {
  background: #eaecff;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>